const permissions = {
  // eslint-disable-next-line no-unused-vars
  model (lang, options) {
    return {
      home: {
        type: 'Boolean',
        title: lang.model.home
      },
      scheduler: {
        type: 'Object',
        title: lang.model.scheduler.title,
        only_me: {
          type: 'Boolean',
          title: lang.model.scheduler.only_me
        },
        launches: {
          type: 'Boolean',
          title: lang.model.scheduler.launches
        },
        calendar: {
          type: 'Boolean',
          title: lang.model.scheduler.calendar
        },
        list: {
          type: 'Boolean',
          title: lang.model.scheduler.list
        },
        actions: {
          type: 'Object',
          title: lang.model.actions.title,
          view: {
            type: 'Boolean',
            title: lang.model.actions.view
          },
          new: {
            type: 'Boolean',
            title: lang.model.actions.new
          },
          edit: {
            type: 'Boolean',
            title: lang.model.actions.edit
          },
          delete: {
            type: 'Boolean',
            title: lang.model.actions.delete
          }
        }
      },
      orders: {
        type: 'Object',
        title: lang.model.orders.title,
        /* by_type: {
          type: 'Object',
          title: lang.model.orders.by_type,
          value: {
            type: 'Select',
            title: lang.model.orders.type,
            options: options.orders.types
          }
        },
        by_status: {
          type: 'Object',
          title: lang.model.orders.by_status,
          min: {
            type: 'Select',
            title: lang.model.status.from,
            options: options.orders.status
          },
          max: {
            type: 'Select',
            title: lang.model.status.to,
            options: options.orders.status
          }
        }, */
        by_created: {
          type: 'Boolean',
          title: lang.model.orders.by_created
        },
        viewprices: {
          type: 'Boolean',
          title: lang.model.orders.viewprices
        },
        historyinfo: {
          type: 'Boolean',
          title: lang.model.orders.historyinfo
        },
        comissions: {
          type: 'Boolean',
          title: lang.model.orders.comissions
        },
        actions: {
          type: 'Object',
          title: lang.model.actions.title,
          view: {
            type: 'Boolean',
            title: lang.model.actions.view
          },
          new: {
            type: 'Boolean',
            title: lang.model.actions.new
          },
          edit: {
            type: 'Boolean',
            title: lang.model.actions.edit
          },
          repeat: {
            type: 'Boolean',
            title: lang.model.actions.repeat
          },
          /* status: {
            type: 'Object',
            title: lang.model.actions.status,
            min: {
              type: 'Select',
              title: lang.model.status.from,
              options: options.orders.status
            },
            max: {
              type: 'Select',
              title: lang.model.status.to,
              options: options.orders.status
            }
          }, */
          paid: {
            type: 'Boolean',
            title: lang.model.actions.paid
          },
          cancel: {
            type: 'Boolean',
            title: lang.model.actions.cancel
          },
          delete: {
            type: 'Boolean',
            title: lang.model.actions.delete
          }
        }
      },
      catalog: {
        type: 'Object',
        title: lang.model.catalog.title,
        stock: {
          type: 'Boolean',
          title: lang.model.catalog.stock
        },
        services: {
          type: 'Object',
          title: lang.model.catalog.services,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        items: {
          type: 'Object',
          title: lang.model.catalog.items,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        categories: {
          type: 'Object',
          title: lang.model.catalog.categories,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        additional: {
          type: 'Object',
          title: lang.model.catalog.additional,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        }
      },
      customers: {
        type: 'Object',
        title: lang.model.customers,
        actions: {
          type: 'Object',
          title: lang.model.actions.title,
          view: {
            type: 'Boolean',
            title: lang.model.actions.view
          },
          new: {
            type: 'Boolean',
            title: lang.model.actions.new
          },
          edit: {
            type: 'Boolean',
            title: lang.model.actions.edit
          },
          delete: {
            type: 'Boolean',
            title: lang.model.actions.delete
          }
        }
      },
      historic: {
        type: 'Object',
        title: lang.model.historic.title,
        orders: {
          type: 'Boolean',
          title: lang.model.historic.orders
        },
        catalog: {
          type: 'Boolean',
          title: lang.model.historic.catalog
        },
        customers: {
          type: 'Boolean',
          title: lang.model.historic.customers
        },
        graphs: {
          type: 'Boolean',
          title: lang.model.historic.graphs
        },
        statistics: {
          type: 'Boolean',
          title: lang.model.historic.statistics
        }
      },
      financial: {
        type: 'Object',
        title: lang.model.financial.title,
        summary: {
          type: 'Boolean',
          title: lang.model.financial.summary
        },
        overview: {
          type: 'Boolean',
          title: lang.model.financial.overview
        },
        cash_flow: {
          type: 'Object',
          title: lang.model.financial.cash_flow,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        bills: {
          type: 'Object',
          title: lang.model.financial.bills,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        salary: {
          type: 'Object',
          title: lang.model.financial.salary,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        reports: {
          type: 'Boolean',
          title: lang.model.financial.reports
        }
      },
      users: {
        type: 'Object',
        title: lang.model.users,
        actions: {
          type: 'Object',
          title: lang.model.actions.title,
          view: {
            type: 'Boolean',
            title: lang.model.actions.view
          },
          new: {
            type: 'Boolean',
            title: lang.model.actions.new
          },
          edit: {
            type: 'Boolean',
            title: lang.model.actions.edit
          },
          delete: {
            type: 'Boolean',
            title: lang.model.actions.delete
          }
        }
      },
      config: {
        type: 'Object',
        title: lang.model.config.title,
        app: {
          type: 'Boolean',
          title: lang.model.config.app
        },
        themes: {
          type: 'Boolean',
          title: lang.model.config.themes
        },
        permissions: {
          type: 'Object',
          title: lang.model.config.permissions,
          actions: {
            type: 'Object',
            title: lang.model.actions.title,
            view: {
              type: 'Boolean',
              title: lang.model.actions.view
            },
            new: {
              type: 'Boolean',
              title: lang.model.actions.new
            },
            edit: {
              type: 'Boolean',
              title: lang.model.actions.edit
            },
            delete: {
              type: 'Boolean',
              title: lang.model.actions.delete
            }
          }
        },
        defaults: {
          type: 'Boolean',
          title: lang.model.config.defaults
        }
      },
      profile: {
        type: 'Object',
        title: lang.model.profile,
        edit: {
          type: 'Boolean',
          title: lang.model.actions.edit
        }
      },
      admin: {
        type: 'Boolean',
        title: lang.model.admin
      }
    }
  },
  presets (lang) {
    return [
      {
        title: lang.new.presets.customer,
        scheduler: false,
        permissions: {
          home: true,
          scheduler: false,
          orders: {
            /* by_type: false,
            by_status: false, */
            by_created: true,
            viewprices: true,
            historyinfo: false,
            comissions: false,
            actions: {
              view: true,
              new: true,
              edit: false,
              status: false,
              paid: false,
              cancel: false,
              delete: false
            }
          },
          catalog: false,
          additional: false,
          customers: false,
          historic: false,
          financial: false,
          users: false,
          config: false,
          profile: {
            edit: true
          },
          admin: false
        }
      },
      {
        title: lang.new.presets.deliveryman,
        permissions: {
          home: true,
          scheduler: false,
          orders: {
            /* by_type: {
              value: 1
            },
            by_status: {
              min: 2,
              max: 3
            }, */
            by_created: false,
            viewprices: true,
            historyinfo: false,
            comissions: false,
            actions: {
              view: true,
              new: false,
              edit: false,
              status: {
                min: 3,
                max: 4
              },
              paid: false,
              cancel: false,
              delete: false
            }
          },
          catalog: false,
          additional: false,
          customers: false,
          historic: false,
          financial: false,
          users: false,
          config: false,
          profile: {
            edit: false
          },
          admin: false
        }
      },
      {
        title: lang.new.presets.cashier,
        permissions: {
          home: true,
          scheduler: {
            only_me: false,
            launches: true,
            calendar: true,
            list: true,
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          orders: {
            /* by_type: false,
            by_status: false, */
            by_created: false,
            viewprices: true,
            historyinfo: true,
            comissions: false,
            actions: {
              view: true,
              new: true,
              edit: true,
              status: {
                min: 1,
                max: 4
              },
              paid: true,
              cancel: true,
              delete: false
            }
          },
          catalog: false,
          additional: false,
          customers: {
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: false
            }
          },
          historic: false,
          financial: false,
          users: false,
          config: false,
          profile: {
            edit: true
          },
          admin: false
        }
      },
      {
        title: lang.new.presets.manager,
        permissions: {
          home: true,
          scheduler: {
            only_me: false,
            launches: true,
            calendar: true,
            list: true,
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          orders: {
            /* by_type: false,
            by_status: false, */
            by_created: false,
            viewprices: true,
            historyinfo: true,
            comissions: true,
            actions: {
              view: true,
              new: true,
              edit: true,
              status: {
                min: 1,
                max: 4
              },
              paid: true,
              cancel: true,
              delete: false
            }
          },
          catalog: {
            stock: true,
            services: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            items: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            categories: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            additional: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            }
          },
          customers: {
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          historic: {
            orders: true,
            catalog: true,
            customers: true,
            graphs: true,
            statistics: true,
            closing: true,
            records: true
          },
          financial: {
            summary: true,
            overview: false,
            cash_flow: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: false
              }
            },
            bills: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: false
              }
            },
            salary: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: false
              }
            },
            reports: true
          },
          users: {
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          config: {
            app: false,
            themes: true,
            permissions: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            defaults: true
          },
          profile: {
            edit: true
          },
          admin: false
        }
      },
      {
        title: lang.new.presets.administrator,
        permissions: {
          home: true,
          scheduler: {
            only_me: false,
            launches: true,
            calendar: true,
            list: true,
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          orders: {
            /* by_type: false,
            by_status: false, */
            by_created: false,
            viewprices: true,
            historyinfo: true,
            comissions: true,
            actions: {
              view: true,
              new: true,
              edit: true,
              status: {
                min: 1,
                max: 4
              },
              paid: true,
              cancel: true,
              delete: true
            }
          },
          catalog: {
            stock: true,
            services: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            items: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            categories: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            additional: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            }
          },
          customers: {
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          historic: {
            orders: true,
            catalog: true,
            customers: true,
            graphs: true,
            statistics: true,
            closing: true,
            records: true
          },
          financial: {
            summary: true,
            overview: true,
            cash_flow: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            bills: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            salary: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            reports: true
          },
          users: {
            actions: {
              view: true,
              new: true,
              edit: true,
              delete: true
            }
          },
          config: {
            app: true,
            themes: true,
            permissions: {
              actions: {
                view: true,
                new: true,
                edit: true,
                delete: true
              }
            },
            defaults: true
          },
          profile: {
            edit: true
          },
          admin: false
        }
      }
    ]
  }
}

/* for (var key in permissions) {
  // console.log(key)
  // console.log('[' + JSON.stringify(permissions[key]) + ']')
  console.log('$prm[] = json_decode(\'' + JSON.stringify(permissions[key]) + '\');')
} */

export default permissions
